import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';
import PublisherActions from './PublisherActions';
import CurrencyActions from './CurrencyActions';
import SessionActions from './SessionActions';
import runtimeConfig from '../config/runtimeConfig';
import { Cookies } from 'react-cookie';

const { dispatch, getState } = store;
const cookies = new Cookies();
const UserInfoActions = {
    init() {
        PublisherActions.getRanks();
        try {
            PublisherActions.getContactTypes();
            PublisherActions.getTimezonesList();
            CurrencyActions.getCurrencies();
            CurrencyActions.getPaymentMethods();
            CurrencyActions.getPaymentSystems();
            CurrencyActions.getAllowPaymentSystems();

            if ('/' === window.location.pathname
                && !cookies.get(runtimeConfig.notShowNoPaymentMsg)
                && !cookies.get(runtimeConfig.notShowNoActivePaymentMsg)
            ) {
                CurrencyActions.getPaymentMethodStat();
            }
        } catch (error) {
            console.warn('Failed to initialize some data:', error.message);
        }

        SessionActions.saveUserID();

        try {
            UserInfoActions.getServerStorage();
        } catch (error) {
            console.warn('Failed to initialize server storage:', error.message);
        }
    },

    loadInfo(params) {
        return api.getUser(params)
        .then(data => {
            dispatch({
                type  : AppConstants.USER_INFO_LOAD_SUCCESS,
                items : data.response || {}
            });
        })
        .catch(err => {
            handleError(err, () => {
                dispatch({
                    type: AppConstants.USER_INFO_LOAD_FAIL,
                    error: err
                });
            });
        });
    },

    edit(params) {
        return api.userEdit(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.USER_EDIT_SUCCESS,
                    items : data.response || {}
                });

                return data.response;
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.USER_EDIT_FAIL,
                        error: err
                    });
                });

                return err;
            });
    },

    changePassword(params) {
        return api.changePassword(params)
            .then(data => {
                return data.response;
            })
            .catch(err => {
                handleError(err, () => {});
                return err;
            });
    },

    getServerStorage(params = {}) {
        params.client_id = runtimeConfig.clientId;

        dispatch({
            type  : AppConstants.SERVER_STORAGE_START_LOADING
        });

        return api.getServerStorage(params)
            .then(data => {
                dispatch({
                    type  : AppConstants.SERVER_STORAGE_SUCCESS,
                    items : data.response && JSON.parse(data.response) || {}
                });
            })
            .catch(err => {
                console.warn('Failed to load server storage:', err.message);
                dispatch({
                    type  : AppConstants.SERVER_STORAGE_SUCCESS,
                    items : {}
                });
                return err;
            });
    },

    setServerStorage(params) {
        const storeData = params && params.data ? JSON.parse(params.data) : getState().serverStorage.store;

        let requestParams = {
            client_id: runtimeConfig.clientId,
            data: params && params.data ? params.data : JSON.stringify(storeData)
        };

        dispatch({
            type: AppConstants.SERVER_STORAGE_START_LOADING
        });

        return api.setServerStorage(requestParams)
            .then(data => {
                dispatch({
                    type  : AppConstants.SERVER_STORAGE_SUCCESS,
                    items : storeData
                });
            })
            .catch(err => {
                handleError(err, () => {});
                return err;
            });
    }
};

export default UserInfoActions;
